import { useEffect, useState } from 'react'

/** Scroll offset at which `.sticky` is added to `.to-be-sticky`. */
export const STICKY_OFFSET = 80

/**
 * Sticky-header state: `.sticky` is present while `window.scrollY > 80`, removed below it.
 */
export function useStickyClass(offset: number = STICKY_OFFSET): boolean {
  const [stuck, setStuck] = useState(() => (typeof window === 'undefined' ? false : window.scrollY > offset))

  useEffect(() => {
    const onScroll = () => setStuck(window.scrollY > offset)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [offset])

  return stuck
}
